import React, { useState } from 'react';
import OpenQuestionsExercise from './OpenQuestionsExercise';
import './OpenQuestionsExerciseBoard.css';

const OPEN_QUESTIONS_ICON = (
  <span style={{
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 48, height: 48, borderRadius: 12, background: 'linear-gradient(135deg, #4f46e5 0%, #6366f1 100%)', marginRight: 20
  }}>
    <svg width="28" height="28" viewBox="0 0 24 24" fill="white">
      <path d="m12 6.0211c-1.1046 0-2 .89858-2 2.00704v1.01742c0 .55422-.44771 1.00354-1 1.00354s-1-.44932-1-1.00354v-1.01742c0-2.21691 1.79086-4.01407 4-4.01407h.1126c2.147 0 3.8874 1.74655 3.8874 3.90103 0 1.03461-.4096 2.02685-1.1386 2.7584l-1.0004 1.004c-.5513.5532-.861 1.3035-.861 2.0859v.2858c0 .5543-.4477 1.0036-1 1.0036s-1-.4493-1-1.0036v-.2858c0-1.3147.5204-2.5755 1.4467-3.5051l1.0005-1.00395c.354-.35519.5528-.83694.5528-1.33925 0-1.04603-.845-1.894-1.8874-1.894z"/>
      <path d="m12 18.0633c.5523 0 1-.4493 1-1.0035s-.4477-1.0035-1-1.0035-1 .4493-1 1.0035.4477 1.0035 1 1.0035z"/>
      <path clipRule="evenodd" d="m0 3.01055c0-1.66268 1.34315-3.01055 3-3.01055h18c1.6569 0 3 1.34787 3 3.01055v14.04925c0 1.6627-1.3431 3.0105-3 3.0105h-2.7861c-.2308 0-.4545.0802-.6332.2269l-3.681 3.0223c-1.1051.9073-2.6943.9073-3.7994 0l-3.68099-3.0223c-.17866-.1467-.40239-.2269-.63324-.2269h-2.78607c-1.65685 0-3-1.3478-3-3.0105zm3-1.00352c-.55228 0-1 .44929-1 1.00352v14.04925c0 .5542.44772 1.0035 1 1.0035h2.78607c.69253 0 1.36373.2404 1.89972.6805l3.68101 3.0223c.3683.3025.8981.3025 1.2664 0l3.681-3.0223c.536-.4401 1.2072-.6805 1.8997-.6805h2.7861c.5523 0 1-.4493 1-1.0035v-14.04925c0-.55423-.4477-1.00352-1-1.00352z" fillRule="evenodd"/>
    </svg>
  </span>
);

const OpenQuestionsExerciseBoard = ({
  exerciseData, exerciseType: _exerciseType, onUpdate, isSelected, onSelect, onExpand,
  isExpanded: isExpandedProp, onClose,
  isStudent = false, myState = {}, otherState = {}, updateState = () => {},
}) => {
  const [isExpandedLocal, setIsExpandedLocal] = useState(false);
  const isExpanded = isExpandedProp !== undefined ? isExpandedProp : isExpandedLocal;
  const { questions, title, level } = exerciseData;

  if (!questions || !Array.isArray(questions)) {
    return (
      <div className="open-questions-board-error">
        <p>Error: Invalid Open Questions exercise data</p>
      </div>
    );
  }

  return (
    <div className="open-questions-exercise-board">
      {!isExpanded ? (
        <div
          className={`open-questions-preview unified-exercise-preview oq-board-card${isSelected ? ' is-selected' : ''}`}
          onClick={() => {
            if (isExpandedProp === undefined) setIsExpandedLocal(true);
            if (onSelect) onSelect();
            if (onExpand) onExpand();
          }}
        >
          {OPEN_QUESTIONS_ICON}
          <div className="unified-preview-main">
            <div className="unified-preview-title">{title || 'Open Questions Exercise'}</div>
            <div className="unified-preview-meta">
              {questions.length} questions · Level: {level || 'B1'}
            </div>
          </div>
          <button className="unified-preview-btn">
            Start Exercise
          </button>
        </div>
      ) : (
        <div className="open-questions-expanded">
          <OpenQuestionsExercise
            questions={questions}
            title={title}
            level={level}
            onClose={() => { if (isExpandedProp === undefined) setIsExpandedLocal(false); if (onClose) onClose(); }}
            onUpdate={onUpdate}
            isBoard={true}
            isStudent={isStudent}
            myState={myState}
            otherState={otherState}
            updateState={updateState}
          />
        </div>
      )}
    </div>
  );
};

export default OpenQuestionsExerciseBoard; 